/* eslint-disable @typescript-eslint/no-explicit-any */

import { SubscriptionPackagesOutput } from '@/api/gql/graphql';
import { FormMode } from '@/pages/Coupons/coupons.hook';
import { create } from 'zustand';

type PackageStore = {
  packageDeletionModal: boolean;
  openPackageDeletionModal: () => void;
  formMode: FormMode;
  setFormMode: (mode: FormMode) => void;
  packageId: string | '';
  setPackageId: (id: string | '') => void;
  subsPackage: any | null;
  setSubsPackage: (subsPackage: SubscriptionPackagesOutput | null) => void;
  isOpenPackageFormModal: boolean;
  openPackageFormModal: () => void;
  setPackageListLimit: (packageListLimit: number) => void;
  packageListLimit: number;
};

export const usePackageStore = create<PackageStore>((set) => ({
  packageListLimit: 10,
  formMode: 'create',
  setPackageListLimit: (packageListLimit) => set({ packageListLimit }),
  setFormMode: (mode) => set({ formMode: mode }),
  packageId: '',
  setPackageId: (id) => set({ packageId: id }),
  subsPackage: null,
  setSubsPackage: (subsPackage) => set({ subsPackage }),
  packageDeletionModal: false,
  isOpenPackageFormModal: false,
  openPackageFormModal: () =>
    set((state) => ({ isOpenPackageFormModal: !state.isOpenPackageFormModal })),
  openPackageDeletionModal: () =>
    set((state) => ({ packageDeletionModal: !state.packageDeletionModal })),
}));
